import React from 'react';
import { ExceedsMasteryIcon } from "./ExceedsMasteryIcon.js";
import { MasteryIcon } from "./MasteryIcon.js";
import { NearMasteryIcon } from "./NearMasteryIcon.js";
import { RemediationIcon } from "./RemediationIcon.js";
import { NoEvidenceIcon } from "./NoEvidenceIcon.js";
import { UnassessedIcon } from "./UnassessedIcon.js";
var MASTERY_LEVEL_ICONS = {
  exceeds_mastery: ExceedsMasteryIcon,
  mastery: MasteryIcon,
  near_mastery: NearMasteryIcon,
  remediation: RemediationIcon,
  no_evidence: NoEvidenceIcon,
  unassessed: UnassessedIcon
};
export var MasteryLevelIcon = function MasteryLevelIcon(_ref) {
  var masteryLevel = _ref.masteryLevel,
    fill = _ref.fill,
    width = _ref.width,
    height = _ref.height,
    style = _ref.style,
    ariaHidden = _ref.ariaHidden,
    ariaLabel = _ref.ariaLabel;
  var Icon = MASTERY_LEVEL_ICONS[masteryLevel];
  if (!Icon) {
    console.warn("MasteryLevelIcon: No icon found for mastery level \"".concat(masteryLevel, "\""));
    return null;
  }
  return /*#__PURE__*/React.createElement(Icon, {
    fill: fill,
    width: width,
    height: height,
    style: style,
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel
  });
};
export default MasteryLevelIcon;